import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ProductReview } from '../../../common/generated-types';
import { NGXLogger } from 'ngx-logger';
import { TitleInfo, TopReviewsData } from '../../../common/interfaces';

@Component({
    selector: 'vsf-top-reviews',
    templateUrl: './top-reviews.component.html',
    styleUrls: ['./top-reviews.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TopReviewsComponent implements OnInit {
    constructor(private logger: NGXLogger, ) {}
    @Input() topReviews: TopReviewsData;
    @Input() isMobile: boolean;
    @Input() linePadding: string;
    @Input() titleInfo: TitleInfo | null = null;
    @Input() displayReviewAssets: boolean = false;
    reviews: ProductReview[] = [];
    ngOnInit(): void {
        this.reviews = this.topReviews.reviews as ProductReview[];
    }
}
